import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { instructor, schoolInfo, images } from '../data/mock';
import { Award, Users, Star, CheckCircle } from 'lucide-react';

const InstructorSection = () => {
  const { t } = useLanguage();

  const achievements = [
    { en: 'Certified Ballet Instructor', id: 'Instruktur Balet Bersertifikat' },
    { en: 'Years of Teaching Experience', id: 'Bertahun-tahun Pengalaman Mengajar' },
    { en: '100+ Students Trained', id: '100+ Siswa Terlatih' },
    { en: 'Specialized in Children Education', id: 'Spesialis Pendidikan Anak' },
  ];

  return (
    <section id="instructor" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <span className="inline-block text-[#8B1C1C] font-semibold text-sm uppercase tracking-wider mb-4">
              {t('Meet Your Instructor', 'Kenali Instruktur Anda')}
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1e1919] mb-4">
              {instructor.name}
            </h2>
            <p className="text-[#8B1C1C] font-semibold text-lg mb-6">
              {t(instructor.titleEn, instructor.titleId)}
            </p>
            <p className="text-[#736c64] text-lg leading-relaxed mb-8">
              {t(instructor.bioEn, instructor.bioId)}
            </p>

            {/* Achievements */}
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {achievements.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-[#8B1C1C]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-4 h-4 text-[#8B1C1C]" />
                  </div>
                  <span className="text-[#1e1919] text-sm">{t(item.en, item.id)}</span>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="flex gap-8">
              <div className="text-center">
                <p className="text-3xl font-bold text-[#8B1C1C]">{schoolInfo.studentsCount}</p>
                <p className="text-[#736c64] text-sm">{t('Students', 'Siswa')}</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-bold text-[#8B1C1C]">{schoolInfo.yearsExperience}</p>
                <p className="text-[#736c64] text-sm">{t('Years', 'Tahun')}</p>
              </div>
              <div className="text-center">
                <p className="text-3xl font-bold text-[#8B1C1C]">5.0</p>
                <p className="text-[#736c64] text-sm">{t('Rating', 'Rating')}</p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-[#f0efed]">
              <img
                src={images.instructor}
                alt={instructor.name}
                className="w-full h-auto object-contain"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#8B1C1C]/20 to-transparent" />
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-[#8B1C1C] text-white rounded-2xl p-6 shadow-xl">
              <Award className="w-8 h-8 mb-2" />
              <p className="font-bold">{t('Certified', 'Bersertifikat')}</p>
              <p className="text-sm text-white/80">{t('Professional', 'Profesional')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InstructorSection;
